import { Trick } from '../models/trick'
import { TrickDto } from '../dtos/trick.dto'
import { Card } from '../models/card'

export const trickMapper = {
  mapToTrick(trickDto: TrickDto): Trick {
    return {
      userId: trickDto.userId,
      trickRoundNumber: trickDto.trickRoundNumberNumber,
      card: new Card(trickDto.card),
    }
  },
}
